import React, { useEffect, useState } from "react";
import "./regionDetection.scss";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { regionDetection, regionDetectionCountry } from "../../../../constants/timezone";
import { findCurretRegion } from "../../../../utils/helper";

interface IRegionDetectionProps {
  onCloseModal: () => void;
}

const RegionDetection: React.FC<IRegionDetectionProps> = ({ onCloseModal }) => {
  const { contentModal, countryId } =
    useSelector((state: RootState) => ({
      contentModal: state.applicationReducer.contentModal,
      countryId: state.applicationReducer.countryId
    }));
  const dispatch = useDispatch();
  const [content, setContent] = useState<any>();


  const onCloseRedirectionModal = () => {
    onCloseModal()
    if(contentModal?.onCloseModal){
      contentModal?.onCloseModal()
    }
    var date = new Date();
    date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    document.cookie = `isSiteVerified=true; path=/; secure; expires=${expires}`;
  };


  useEffect(() => {
    if (countryId) {
      const currentRegion = findCurretRegion();
      if (currentRegion) {
        setContent(regionDetection[currentRegion!]);
      }
    }
  }, [countryId])

  return (
    <div className="region-detection-wrapper">
      <div className="modal-body">
        <div className="region-delecation">
          <h1>Hmm...</h1>
          <p className="title-first">{content?.title.replace('###COUNTRY###',regionDetectionCountry[countryId]?.name )}</p>
          <p className="title-sec">{content?.question}</p>

          <div className="region-options">
            <a href={content?.redirectLink} onClick={onCloseRedirectionModal}>
              <div className="region-box">
                <img src={content?.flagURL} alt="Region flag" />
                <div className="flag-des">{content?.flagTitle}</div>
              </div>
            </a>
            <div className="region-box usa" onClick={onCloseRedirectionModal}>
              <img src={regionDetectionCountry[countryId]?.continueToFlag} alt="flag" />
              <div className="flag-des">{regionDetectionCountry[countryId]?.continueToTitle}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegionDetection;
